const MALE_GENDER = '1';
const FEMALE_GENDER = '2';
const UNKNOWN_GENDER = '3';

export { MALE_GENDER, FEMALE_GENDER, UNKNOWN_GENDER };
